const Fonts = [
    "Arial", "Tahoma", "Courier  New",
    "Trebuchet MS", "Garamond", "Georgia",
    "Verdana",
    "Copperplate",
    "Papyrus", "Helvetica", "Monaco", "	Brush Script MT", 
]

export default Fonts;